import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

import { ui } from '@/constants';
import { DietaryTagUI, MonoMenuTopLevelNutritionDetailsSection } from '@/models';

@Component({
  name: 'CmgMobileNutritionDetailsModal',
})
export default class CmgMobileNutritionDetailsModal extends Vue {
  nutritionDetailsOrdering = ['tcal', 'tfat', 'prot', 'carb', 'sodi', 'Vitamins & Minerals'];

  get visible(): boolean {
    return this.$appStore.state.ui.modals.mobileNutritionDetails.visible;
  }

  get currentNutrition() {
    return this.$store.state.mealBuilderV2.nutrition;
  }

  get mealType(): string {
    return this.$store.state.mealBuilderV2.topLevelMenuItemTitle;
  }

  get dietaryTags(): DietaryTagUI[] {
    if (this.$appStore.state.customer.profile?.dietaryTags) {
      // Only one badge from each group
      const tagBadges: {
        [key: string]: DietaryTagUI;
      } = {};
      this.$appStore.state.customer.profile?.dietaryTags
        .map(tag => (this.$services.monoMenu.getDietaryTagsLookup() as any)[tag])
        .filter(t => t != undefined)
        .forEach(t => (tagBadges[t!.tagGroupId] = t!));

      return Object.values(tagBadges);
    }

    return [];
  }

  get showNutritionPreferences(): boolean {
    return this.dietaryTags.length !== 0;
  }
  
  get searchIconUrl(): string {
    return this.$appStore.state.cms.images.icons.search.default;
  }

  get getFullNutritionURL(): string {
    return this.$appStore.state.cms.fullNutritionURL ?? '';
  }

  get nutritionDetailSections() {
    return this.$services.monoMenu.getNutritionDetailSections().sort((a, b) => this.getNutritionDetailSectionIndex(a) - this.getNutritionDetailSectionIndex(b));
  }

  currentNutritionValue(key: string, asPercentage: boolean = false) {
    if (asPercentage) {
      const total = this.currentNutrition['tfat'] + this.currentNutrition['prot'] + this.currentNutrition['carb'];

      return total ? Math.round((this.currentNutrition[key]/total)*100) : 0;
    }

    return Math.round(this.currentNutrition[key]);
  }

  onClose() {
    this.$services.ui.setModalVisibility('mobileNutritionDetails', false);
  }

  onClickFullFacts() {
    window.open(this.getFullNutritionURL, '_blank');
  }

  getNutritionDetailSectionIndex(section: MonoMenuTopLevelNutritionDetailsSection): number {
    if (section.key) {  
      return this.nutritionDetailsOrdering.indexOf(section.key);
    }

    // Currently, Vitamins & Minerals does not have a key
    return this.nutritionDetailsOrdering.indexOf(section.name);
  }
}
